import { cn } from "@/utils/classnames";

// 占位，加载中，骨架
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-surface animate-pulse rounded-md", className)}
      {...props}
    />
  );
}

export { Skeleton };